<template>
  <div class="card" :class="setClassModifiers('card--')">
    <div class="card__gradient"></div>
    <div class="card__main">
      <div class="card__header" v-if="$slots.header">
        <div class="card__header-bg"></div>
        <slot name="header"></slot>
      </div>

      <div class="card__content">
        <slot></slot>
      </div>
    </div>
    <div class="card__controls">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  name: 'card',

  mixins: [setClassModifiers],

  props: {
    /**
     * @values dark, purple
     */
    color: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="scss">
  .card {
    position: relative;
    border-radius: $border-radius-large;
    overflow: hidden;
    background-color: $color-purple-black;
    color: $color-white;

    &__header {
      position: relative;

      &-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: $color-space-light;
        opacity: 0.1;
      }
    }

    &__content, &__header{
      padding: $default-spacing-mobile;
      @include respond(tab-port) {
        padding: $default-spacing-mobile;
      }
    }

    &__controls {
      position: absolute;
      right: 1rem;
      top: 1rem;

      & > * {
        font-size: 1.8rem!important;

        & > a {
          color: $color-white;
        }

        & > a:link {
          font-size: 1.8rem!important;
          color: $color-white;
        }
      }
    }

    &__gradient {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(181, 187, 242, 0.4) 0%, rgba(19, 22, 46, 0.4) 100%);
      opacity: .4;
    }

    &--purple {
      background-color: $color-purple;
    }
  }
</style>
